import { DOCUMENT, Location } from '@angular/common'
import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AnalyticsService, ApiService, AuthService, Cry, GlobalService, LoadScriptsService, orientation, sleep, StyleLoader, timeOut, verifyLoggedIn } from '@y4w-core'
import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency'
import { SubSink } from 'subsink'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private subs = new SubSink()
  networkBlock = false
  isLocal: string
  bg: string

  constructor(
    public router: Router,
    public g: GlobalService,
    private styleLoader: StyleLoader,
    private loadSrv: LoadScriptsService,
    private location: Location,
    private analitycs: AnalyticsService,
    private auth: AuthService,
    private api: ApiService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
  ) {
    this.verifyNetwork()
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe()
  }

  async ngOnInit() {
    this.isLocal = Cry.get('isLocal') || false
    this.bg = orientation() === 'landscape' ? this.g.program?.images?.desktopBg : this.g.program?.images?.mobileBg

    // required check for native IOS apps after 2secs
    timeOut(() => {
      if (this.g.isIOS) {
        try {
          AppTrackingTransparency.getStatus().then(res => console.log(`_Admin debug_\ngetStatus():\n${JSON.stringify(res)}`))
            .catch(e => console.log(`_Admin debug_\ngetStatus:\n${e.message || e}`))
          AppTrackingTransparency.requestPermission().then((res: any) => {
            console.log(`_Admin debug_\nrequestPermission():\n${JSON.stringify(res)}`)
            if (this.g.isBrowser) Cry.setLocal('accepted-gdpr', true)
          })
            .catch(e => console.log(`_Admin debug_\nrequestPermission():\n${e.message || e}`))
        } catch (e) {
          console.log(`_Admin debug_\nIOSAppTracking:\n${e.message || e}`)
        }
      }
    }, 1000)

    // loadStyle in app.init was not working on the first load
    if (this.g.isBrowser && Cry.get('isLocal')) this.styleLoader.loadStyle(this.g.nick) //  || Cry.get('native')
    else this.styleLoader.loadStyle(this.g.nick, this.g.program.cssUrl)

    // test for SSR
    if (this.g.isBrowser) {
      window['ngNav'] = path => this.router.navigate([path]) // debug on android tablets
    }

    this.persistPubLink()

    await verifyLoggedIn(this.g, this.router, this.auth)

    if (this.g.program.options.segmentsRedirectByType) {
      await sleep(300)
      this.auth.redirectBySegmentType(this.g.user)
    }
    this.loadExternalScripts()

    this.analitycs.trackPageViews()

    try {
      import('@capacitor/app').then((CapacitorApp: any) => {
        if (CapacitorApp && CapacitorApp.hasOwnProperty('addListener')) {
          CapacitorApp.addListener('backButton', ({ canGoBack }) => {
            if (!canGoBack) {
              CapacitorApp.exitApp()
            } else {
              this.location.back()
            }
          })
        }
      })
    } catch (e) {
      console.log('CapacitorApp is not installed')
    }

    // hides the app-shell
    this._document.querySelector('.js-bootstrap')['style'].display = 'none'
  }

  loadExternalScripts() {
    const urls = [
      'https://cdn.easypay.pt/checkout/2.6.2/',
      'assets/js/font-awesome.js',
      'assets/js/bootstrap-v5-beta3.bundle.min.js'
    ]
    for (const url of urls) {
      this.loadSrv.loadScript(url).subscribe(() => null)
    }
  }

  private persistPubLink() {
    const path = window.location.pathname
    const pub = Cry.get('pub')
    if (pub && !path.includes('/pub/')) this.router.navigate([`/pub/${pub}`])
  }

  private verifyNetwork() {
    if (this.g.program && this.g.program.options.ipWhitelist) {
      this.api.post('open/startapp', this.g.nick, true).toPromise().then(res => {
        const parsed = JSON.parse(res.ic)
        if (typeof parsed === 'object') {
          (document as any).querySelector('.js-bootstrap')['style'].display = 'none'
          this.networkBlock = true
        }
      })
    }
  }

}
